import { styled } from '@mui/material/styles';
import { Box, alpha, Tooltip, TooltipProps, Paper } from '@mui/material';
import DatePicker from 'views/common/components/UI/DatePicker';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .TPWGuidedAlert': {
    backgroundColor: 'transparent',
    bagroundImage: 'unset',
    padding: theme.spacing(0, 1),
    color: theme.palette.primary.main,
    fontWeight: '500',
    '& .MuiAlert-icon': {
      color: theme.palette.primary.main,
      fontSize: theme.spacing(2.5),
    },
  },
  '& .TBWPackageSelector': {
    backgroundColor: 'transparent',
    '& .MuiFormLabel-root': {
      left: theme.spacing(6),
      top: theme.spacing(1.5),
      fontSize: theme.typography.pxToRem(10),
      fontWeight: 700,
      letterSpacing: '0.5px',
      color: theme.palette.text.secondary,
      textTransform: 'uppercase',
      opacity: '1',
      lineHeight: '120%',
      transition: 'unset',
      transform: 'unset',
      '&.Mui-focused': {
        color: `${theme.palette.text.secondary} !important`,
      },
    },
    '& .MuiInputBase-root': {
      paddingLeft: theme.spacing(2),
      backgroundColor: 'transparent',
      border: `1px solid ${theme.palette.border[3]}`,
      borderRadius: theme.spacing(0.5),
      '&:before, &:after': {
        content: 'unset',
      },
    },
    '& .MuiSelect-select': {
      padding: theme.spacing(3.5, 2, 0.75, 0),
      paddingRight: `${theme.spacing(2)} !important`,
      fontSize: theme.spacing(2),
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },
    '& .MuiInputAdornment-root': {
      marginTop: '0 !important',
      '&.TBWPackageSelectorIcon': {
        width: theme.spacing(3),
        height: theme.spacing(3),
        maxHeight: 'unset',
        '& svg': {
          width: theme.spacing(3),
          height: theme.spacing(3),
        },
      },
    },
  },
  '& .bringOwnContainer': {
    position: 'relative',
  },

  '& .newLabel': {
    backgroundColor: theme.palette.success.main,
    position: 'absolute',
    top: '18px',
    right: '2px',
    color: theme.palette.common.fogWhite,
    padding: theme.spacing(0.25, 1),
    transform: 'translateY(-100%)',
    fontSize: theme.typography.pxToRem(12),
    fontWeight: '700',
    borderRadius: 22,
    lineHeight: theme.typography.pxToRem(18),
  },

  '& .TPWSelectInput': {
    '&.Mui-disabled': {
      backgroundColor: theme.palette.text.disabled,
    },
    '&.MuiOutlinedInput-root': {
      '& .MuiInputAdornment-root, .MuiSvgIcon-root ': {
        display: 'none',
      },
    },
    '& .MuiOutlinedInput-input': {
      background: 'transparent',
    },
  },
  '& .TPSTimeSlotsWrapper': {
    '& .TPSTimeSlots': {
      borderRadius: theme.spacing(0.5),
      border: `1px solid ${theme.palette.divider[2]}`,
      padding: theme.spacing(1.5),
      cursor: 'pointer',
      
      '& .TPSTimeSlotsText': {
        letterSpacing: 0.4,
        fontSize: theme.typography.pxToRem(14),
        textAlign: 'center',
        fontWeight: 600,
        lineHeight: theme.spacing(2),
      },
      '&.active': {
        border: `1px solid ${theme.palette.primary.main}`,
      },
    },
  },
  '& .TPSTimeSlotsError': {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    '& .MuiAlert-icon': {
      padding: 0,
      marginRight: theme.spacing(1),
    },
    '& .MuiAlert-message': {
      padding: 0,
    },
  },
  '& .TPSTimeSlotsErrorIcon': {
    fontSize: theme.spacing(2.5),
  },
  '& .TBWError': {
    backgroundColor: theme.palette.error.background,
    fontWeight: 700,
    marginTop: theme.spacing(2),
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    '& .MuiAlert-icon': {
      padding: 0,
      marginRight: theme.spacing(1),
    },
    '& .MuiAlert-message': {
      padding: 0,
    },
  },
  '& .TBWErrorIcon': {
    color: theme.palette.error.light,
    fontSize: theme.spacing(2.5),
  },
  '& .TBWOccurrenceBadge': {
    color: theme.palette.error.light,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: '100%',
    fontWeight: 500,
  },
  '& .TBWSoldOutBadge': {
    verticalAlign: 'text-top',
    marginLeft: theme.spacing(0.8),
  },
}));

export const StyledDatePicker = styled(DatePicker)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  borderRadius: 8,
  border: '1px solid',
  width: theme.typography.pxToRem(330),
  borderColor: theme.palette.divider[7],
  backdropFilter: 'blur(8px)',
   [theme.breakpoints.down('md')]: {
    width: '100%',
    },
  '& .MuiButtonBase-root, .MuiDayCalendar-weekDayLabel': {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 400,
    lineHeight: '140%',
  },
  '& .MuiPickersArrowSwitcher-button .MuiSvgIcon-root': {
    width: theme.typography.pxToRem(24),
    height: theme.typography.pxToRem(24),
  },
}));

export const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  '& .MuiTooltip-arrow': {
    color: theme.palette.common.black,
  },
  '& .MuiTooltip-tooltip': {
    backgroundColor: theme.palette.common.black,
  },
}));

export const StyledMenuPaper = styled(Paper)(({ theme }) => ({
  '&::-webkit-scrollbar': {
    width: theme.spacing(1),
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
    borderRadius: theme.spacing(0.5),
  },
  '&::-webkit-scrollbar-thumb': {
    background: theme.palette.secondary.main,
    borderRadius: theme.spacing(0.5),
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: theme.palette.secondary.light,
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.secondary.main} transparent`,
  '& .TBWPackageItem': {
    border: '1px solid',
    borderColor: 'transparent',
    fontSize: theme.spacing(2),
    padding: theme.spacing(0.75, 1.25),
    transition: 'border-color 0.3s ease',
    [theme.breakpoints.down('md')]: {
      fontSize: theme.spacing(1.75),
      whiteSpace:'normal',
    },
    '&:hover': {
      border: '1px solid',
      borderColor: alpha(theme.palette.common.white, 0.8),
      borderRadius: 4,
    },
  },
}));

export default StyledBox;
